import type { ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { State } from '../types.tsx';

export const getLoadError = (state: State) => state.error;

export const getPinnedFieldsByProjectId = (state: State, projectId?: ProjectId) =>
	projectId ? state?.pinnedFields?.[projectId] : undefined;
